import { createStore, compose, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import {
  connectRouter,
  routerMiddleware
} from "connected-react-router/immutable";
import _ from "lodash";
import { Map } from "immutable";
import { combineReducers } from "redux-immutable";
import { composeWithDevTools } from "redux-devtools-extension";
import globalReducer from "../reducers/globalReducer";
import carousel from "../CommonComponents/Carousel/reducer";
import recommendAnExchangeReducer from "../Epics/Investments/Pages/RecommendFlow/reducer";
import investmentDashboardReducer from "../Epics/Investments/Pages/InvestmentDashboard/reducer";
import investmentOptionDetail from "../Epics/Investments/Pages/InvestmentOptionDetails/reducer";
import grantAgreements from "../Epics/Grants/Pages/GrantAgreement/reducer";
import recommendGrantReducer from "../Epics/Grants/Pages/RecommendGrant/reducer";
import grantsActivity from "../Epics/Grants/Pages/GrantsActivity/reducers";
import myAccountReducer from "../Epics/MyAccounts/reducer";
import monitorReducersEnhancer from "./enhancers/monitorReducer";
import needAssistance from "../CommonComponents/Header/Component/NeedAssistance/reducer";
import loggerMiddleware from "./middlewares/logger";
import history from "../history/history";
import rootRunner from "../sagas/rootSaga";
import { npaFormReducer } from "../Epics/NPA/Pages/reducer";
import documentCentre from "../Epics/DocumentCentre/Pages/reducer";
import exchangeActivity from "../Epics/Investments/Pages/ViewInvestmentExchangeActivity/reducers";
import accountSummary from "../Epics/AccountSummary/Pages/reducer";
import adminSearch from "../Epics/AdminSearch/Pages/reducer.js";
import messagingReducer from "../Epics/Messaging/reducer";
import contributionActivity from "../Epics/Contributions/Pages/ContributionActivity/reducer";
import makeAContributionReducer from "../Epics/Contributions/Pages/MakeAContribution/reducer";
import tiffExchange from "../Epics/Investments/Pages/RecommendFlow/Containers/TIFF/reducer";
import contributionsDashboard from "../Epics/Contributions/Pages/ContributionsDashboard/reducer";
import grantsDashboard from "../Epics/Grants/Pages/GrantsDashboard/reducer";
import suggestACharity from "../Epics/Grants/Pages/SuggestACharity/reducer";
import TransactionSummaryReducer from "../Epics/TransactionSummary/Pages/reducer";
import howItWorks from "../Epics/Grants/Pages/HowItWorks/reducer";
import financialAdvisorDashboard from "../Epics/FinancialAdvisor/reducer";
import zipCode from "../CommonComponents/Zipcode/reducer";

export default function configureStore(preloadedState) {
  const sagaMiddleware = createSagaMiddleware({});
  const routeMiddleware = routerMiddleware(history); // fn will hold an history object

  const middlewares = [loggerMiddleware, routeMiddleware, sagaMiddleware];
  const middlewareEnhancer = applyMiddleware(...middlewares);
  const enhancers = [middlewareEnhancer, monitorReducersEnhancer];
  const composedEnhancers = () => {
    if (process.env.NODE_ENV === "development")
      return composeWithDevTools(...enhancers);
    return compose(...enhancers);
  };

  const saveStoreToLocal = (state, whitelist = []) => {
    try {
      let data = whitelist.map(reducer => {
        return { reducer, value: state.getIn([reducer]).toJS() };
      });

      data = _.mapValues(_.keyBy(data, "reducer"), "value");
      const serialize = JSON.stringify(data);
      sessionStorage.setItem("store", serialize);
    } catch (e) {
      console.error(e);
    }
  };

  const loadStoreFromLocalStorage = state => {
    let stateCopy = state;
    try {
      const serialize = sessionStorage.getItem("store");
      if (!serialize) return state;
      const data = JSON.parse(serialize);
      _.keys(data).forEach(reducer => {
        stateCopy = stateCopy.setIn([reducer], Map(data[reducer]));
      });
    } catch (e) {
      console.error(e);
    }
    return stateCopy;
  };

  preloadedState = loadStoreFromLocalStorage(preloadedState);

  const store = createStore(
    connectRouter(history)(
      combineReducers({
        globalState: globalReducer,
        carousel: carousel,
        recommendAnExchange: recommendAnExchangeReducer,
        investmentDashboard: investmentDashboardReducer,
        investmentOptionDetail: investmentOptionDetail,
        exchangeActivity: exchangeActivity,
        grantAgreements: grantAgreements,
        recommendGrant: recommendGrantReducer,
        myAccount: myAccountReducer,
        npaFormReducer: npaFormReducer,
        grantsActivity: grantsActivity,
        needAssistance: needAssistance,
        documentCentre: documentCentre,
        adminSearch: adminSearch,
        accountSummary: accountSummary,
        messaging: messagingReducer,
        contributionsDashboard: contributionsDashboard,
        makeAContribution: makeAContributionReducer,
        contributionActivity: contributionActivity,
        suggestACharity: suggestACharity,
        tiffExchange: tiffExchange,
        transactionSummary: TransactionSummaryReducer,
        howItWorks: howItWorks,
        financialAdvisorDashboard: financialAdvisorDashboard,
        grantsDashboard: grantsDashboard,
        zipCode: zipCode
      })
    ),
    preloadedState,
    composedEnhancers()
  );

  store.subscribe(() =>
    saveStoreToLocal(store.getState(), ["recommendGrant", "grantAgreements"])
  );
  sagaMiddleware.run(rootRunner);

  return store;
}
